import useMcdApiQuery from './useMcdApiQuery'

export interface IRequest {
  POSTCD?: string // 郵便番号
  CITY_CD?: string // 市区町村コード
}

export interface PostCdValue {
  POSTCD: string // 郵便番号
  TOWN_AREA: string // 町域
  CITY_CD: string // 市区町村コード
  CITY_NAME: string // 市区町村名称
  ADR: string // 住所
}

interface IResponse {
  _obj0?: PostCdValue[]
  isError: boolean
}

/**
 * [GET] SearchPostCdCity.json
 * 郵便番号市区町村を検索する
 * */
export const useSearchPostCdCity = (params: IRequest | undefined) => {
  const url = '/sinfoniacloud/api/SearchPostCdCity.json'
  const query = useMcdApiQuery<IResponse>(url, params, {enabled: !!params})

  return query
}

export default useSearchPostCdCity

/*

{
    "uuid": "7787c844-cdb9-45a4-91ad-d322ab38fe85",
    "documentation": "[PCS/CGTC] 郵便番号を検索する",
    "method": "get",
    "endpoint": "SearchPostCdCity.json",
    "responses": [
        {
            "uuid": "499a5e9d-cdd0-4f4f-b99c-9403b49de9e8",
            "body": "{\n  \"isError\": false,\n  \"body\": {\n    \"_obj0\": [\n      {\n        \"CITY_CD\": \"221015\",\n        \"CITY_NAME\": \"静岡県静岡市葵区\",\n        \"POSTCD\": \"4200857\",\n        \"TOWN_AREA\": \"御幸町\"\n      }\n    ]\n  }\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [
                {
                    "target": "query",
                    "modifier": "POSTCD",
                    "value": "4200857",
                    "invert": false,
                    "operator": "equals"
                }
            ],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": true
        },
        {
            "uuid": "7589135a-8311-4307-8cc6-d4fe6486c526",
            "body": "{\n  \"isError\": false,\n  \"body\": {\n    \"_obj0\": [\n      {\n        \"CITY_CD\": \"131130\",\n        \"CITY_NAME\": \"東京都渋谷区\",\n        \"POSTCD\": \"1500001\",\n        \"TOWN_AREA\": \"神宮前\"\n      }\n    ]\n  }\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [
                {
                    "target": "query",
                    "modifier": "POSTCD",
                    "value": "1500001",
                    "invert": false,
                    "operator": "equals"
                }
            ],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": false
        },
        {
            "uuid": "e7bf1dd9-123b-459c-afe3-41e655e5888e",
            "body": "{\n  \"isError\": false,\n  \"body\": {\n    \"_obj0\": [\n      {\n        \"CITY_CD\": \"012068\",\n        \"CITY_NAME\": \"北海道釧路市\",\n        \"POSTCD\": \"0850847\",\n        \"TOWN_AREA\": \"大町\"\n      }\n    ]\n  }\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "filePath": "",
            "sendFileAsBody": false,
            "rules": [
                {
                    "target": "query",
                    "modifier": "POSTCD",
                    "value": "0850847",
                    "invert": false,
                    "operator": "equals"
                }
            ],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": false,
            "databucketID": "",
            "bodyType": "INLINE"
        },
        {
            "uuid": "74b36921-8cae-49ab-a812-80ba555812aa",
            "body": "{\n  \"isError\": false,\n  \"body\": {\n    \"_obj0\": [\n      {\n        \"CITY_CD\": \"012068\",\n        \"CITY_NAME\": \"北海道釧路市\",\n        \"POSTCD\": \"0850811\",\n        \"TOWN_AREA\": \"興津\"\n      }\n    ]\n  }\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [
                {
                    "target": "query",
                    "modifier": "POSTCD",
                    "value": "0850811",
                    "invert": false,
                    "operator": "equals"
                }
            ],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": false
        },
        {
            "uuid": "9a280f7a-5b7d-40b9-8d72-5d5fe30cd20b",
            "body": "{\n  \"isError\": false,\n  \"body\": {\n    \"_obj0\": [\n      {\n        \"CITY_CD\": \"062120\",\n        \"CITY_NAME\": \"山形県尾花沢市\",\n        \"POSTCD\": \"9994554\",\n        \"TOWN_AREA\": \"芦沢\"\n      },\n      {\n        \"CITY_CD\": \"063410\",\n        \"CITY_NAME\": \"山形県大石田町\",\n        \"POSTCD\": \"9994554\",\n        \"TOWN_AREA\": \"鷹巣（岡草山）\"\n      }\n    ]\n  }\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [
                {
                    "target": "query",
                    "modifier": "POSTCD",
                    "value": "9994554",
                    "invert": false,
                    "operator": "equals"
                }
            ],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": false
        },
        {
            "uuid": "fecf22b4-c8d8-4d99-9979-9b850a388719",
            "body": "{\n  \"isError\": false,\n  \"body\": {\n    \"_obj0\": []\n  }\n}",
            "latency": 0,
            "statusCode": 200,
            "label": "",
            "headers": [],
            "bodyType": "INLINE",
            "filePath": "",
            "databucketID": "",
            "sendFileAsBody": false,
            "rules": [
                {
                    "target": "query",
                    "modifier": "POSTCD",
                    "value": "null",
                    "invert": true,
                    "operator": "equals"
                }
            ],
            "rulesOperator": "OR",
            "disableTemplating": false,
            "fallbackTo404": false,
            "default": false
        }
    ],
    "enabled": true,
    "responseMode": null
}

*/
